import React from 'react';
import { useFela } from '../../..';
import { WithDmId } from '../../../utils/BaseProps';

const defaultStyle = {
  display: 'flex',
  maxWidth: '100%',
  flexDirection: 'column',
  boxSizing: 'border-box',
  flex: '0 0 auto',
};

type BoxProps = WithDmId & {
  /**
   * String oder Komponente, die übergeben werden kann, um ein
   * anderes Element mit den Eigenschaften einer Box zu rendern.
   */
  as?: string | JSX.Element | Function;
  /**
   * Objekt (oder String), das den Inhalt der Komponente bestimmt.
   */
  children: React.ReactNode;
  /**
   * Attribut, das der ref Property des Elements zugewiesen wird.
   */
  reference?: string | React.Ref<any>;
  /**
   * Objekt, mit dem das Styling der Box überschrieben werden kann.
   */
  style?: object;
  [otherProp: string]: any;
};

export default function Box({
  style = {},
  children,
  as: Component = 'div',
  reference,
  dmId = 'dm-box',
  ...otherProps
}: BoxProps): React.ReactElement {
  const { css } = useFela();
  const className = css(defaultStyle, style);
  return (
    // @ts-ignore
    <Component
      className={className}
      ref={reference}
      data-dmid={dmId}
      data-designsystem
      {...otherProps}>
      {children}
    </Component>
  );
}
